import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  locale: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "TabGeneralInquiry",
  uniqId: "tab_general_inquiry",
})((theme, { params }, classes) => {
  return {
    contentContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: 1000,
      justifyContent: "flex-start",
      alignItems: "center",
    },

    instruction: {
      color: "#333",
      textAlign: "left",
      fontFamily:
        params.locale === "en-US"
          ? "Montserrat"
          : params.locale === "zh-CN"
          ? "Noto Sans SC"
          : "Noto Sans TC",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "200%",
      letterSpacing: params.locale === "en-US" ? 0 : "3.6px",
    },

    formContainer: {
      width: "100%",
      height: "fit-content",
      marginTop: 50,
    },
  };
});

export default useStyles;
